(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["capture-reviews"] && !Shopify.designMode) return;
  try {
    
  let activeGalleryImages = [];
  let activeGalleryIndex = 0;
  let currentFeedPage = 1;
  let itemsPerPage = 6;

  function updateFeedPagination() {
    const feedItems = document.querySelectorAll('.js-feed-item');
    if (!feedItems.length) return;

    const totalPages = Math.ceil(feedItems.length / itemsPerPage);
    if (currentFeedPage > totalPages) currentFeedPage = totalPages;
    if (currentFeedPage < 1) currentFeedPage = 1;

    feedItems.forEach((item, idx) => {
      const pageIndex = Math.floor(idx / itemsPerPage) + 1;
      item.style.display = (pageIndex === currentFeedPage) ? 'flex' : 'none';
    });

    const numContainer = document.getElementById('js-feed-page-numbers');
    if (numContainer) {
      let html = '';
      for (let i = 1; i <= totalPages; i++) {
        html += `<button class="capture-page-btn ${i === currentFeedPage ? 'is-active' : ''}" onclick="window.goToFeedPage(${i})">${i}</button>`;
      }
      numContainer.innerHTML = html;
    }
  }

  window.goToFeedPage = function(page) {
    currentFeedPage = page;
    updateFeedPagination();
    const feedSection = document.getElementById('js-more-reviews-feed');
    if (feedSection) {
      feedSection.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }
  };

  function initReviewSection() {
    const track = document.querySelector('.capture-reviews__track');
    const prevBtn = document.querySelector('.capture-reviews__arrow--prev');
    const nextBtn = document.querySelector('.capture-reviews__arrow--next');
    
    if (track && prevBtn && nextBtn) {
      let originalCards = Array.from(track.querySelectorAll('.capture-review-card'));
      const originalCount = originalCards.length;

      if (originalCount > 0) {
        track.querySelectorAll('.capture-review-card--clone').forEach(el => el.remove());

        originalCards.forEach(card => {
          const cloneAfter = card.cloneNode(true);
          cloneAfter.classList.add('capture-review-card--clone');
          track.appendChild(cloneAfter);

          const cloneBefore = card.cloneNode(true);
          cloneBefore.classList.add('capture-review-card--clone');
          track.insertBefore(cloneBefore, track.firstChild);
        });

        let allCards = Array.from(track.querySelectorAll('.capture-review-card'));
        let currentIndex = originalCount;
        let isTransitioning = false;

        function setTrackPosition(idx, animate = true) {
          if (!animate) {
            track.classList.add('no-transition');
          } else {
            track.classList.remove('no-transition');
          }
          const cardWidth = allCards[0].offsetWidth + 24;
          track.style.transform = `translateX(-${idx * cardWidth}px)`;

          if (!animate) {
            track.offsetHeight; 
            track.classList.remove('no-transition');
          }
        }

        setTrackPosition(currentIndex, false);

        nextBtn.addEventListener('click', () => {
          if (isTransitioning) return;
          isTransitioning = true;
          currentIndex++;
          setTrackPosition(currentIndex, true);
        });

        prevBtn.addEventListener('click', () => {
          if (isTransitioning) return;
          isTransitioning = true;
          currentIndex--;
          setTrackPosition(currentIndex, true);
        });

        track.addEventListener('transitionend', () => {
          isTransitioning = false;
          if (currentIndex >= originalCount * 2) {
            currentIndex = originalCount;
            setTrackPosition(currentIndex, false);
          } else if (currentIndex < originalCount) {
            currentIndex = originalCount * 2 - 1;
            setTrackPosition(currentIndex, false);
          }
        });

        window.addEventListener('resize', () => {
          setTrackPosition(currentIndex, false);
        });
      }
    }

    const toggleBtn = document.getElementById('js-toggle-more-reviews');
    const feedContainer = document.getElementById('js-more-reviews-feed');
    const btnText = document.getElementById('js-more-btn-text');
    const btnArrow = document.getElementById('js-more-btn-arrow');

    if (toggleBtn && feedContainer) {
      toggleBtn.addEventListener('click', () => {
        const isHidden = feedContainer.style.display === 'none';
        if (isHidden) {
          feedContainer.style.display = 'block';
          toggleBtn.setAttribute('aria-expanded', 'true');
          if (btnText) btnText.innerText = 'Less reviews';
          if (btnArrow) btnArrow.innerText = '↑';
          updateFeedPagination();
        } else {
          feedContainer.style.display = 'none';
          toggleBtn.setAttribute('aria-expanded', 'false');
          if (btnText) btnText.innerText = 'More reviews';
          if (btnArrow) btnArrow.innerText = '↓';
        }
      });
    }

    const prevPageBtn = document.getElementById('js-feed-prev-btn');
    const nextPageBtn = document.getElementById('js-feed-next-btn');

    if (prevPageBtn) {
      prevPageBtn.addEventListener('click', () => {
        if (currentFeedPage > 1) {
          window.goToFeedPage(currentFeedPage - 1);
        }
      });
    }

    if (nextPageBtn) {
      nextPageBtn.addEventListener('click', () => {
        const feedItems = document.querySelectorAll('.js-feed-item');
        const totalPages = Math.ceil(feedItems.length / itemsPerPage);
        if (currentFeedPage < totalPages) {
          window.goToFeedPage(currentFeedPage + 1);
        }
      });
    }

    document.addEventListener('click', function(e) {
      const trigger = e.target.closest('.js-gallery-trigger');
      if (trigger) {
        const rawImages = trigger.getAttribute('data-images') || '';
        const start = parseInt(trigger.getAttribute('data-start'), 10) || 0;

        activeGalleryImages = rawImages ? rawImages.split('|||') : [];
        activeGalleryIndex = start;

        if (activeGalleryImages.length) openImageModal();
      }
    });

    const imageModal = document.getElementById('capture-review-modal');
    const closeModalBtn = document.getElementById('js-close-modal');
    const modalPrev = document.getElementById('js-modal-prev-btn');
    const modalNext = document.getElementById('js-modal-next-btn');

    if (closeModalBtn) {
      closeModalBtn.addEventListener('click', () => {
        if (imageModal) imageModal.style.display = 'none';
      });
    }

    if (modalPrev) {
      modalPrev.addEventListener('click', () => {
        activeGalleryIndex--;
        if (activeGalleryIndex < 0) activeGalleryIndex = activeGalleryImages.length - 1;
        updateModalPhoto();
      });
    }

    if (modalNext) {
      modalNext.addEventListener('click', () => {
        activeGalleryIndex++;
        if (activeGalleryIndex >= activeGalleryImages.length) activeGalleryIndex = 0;
        updateModalPhoto();
      });
    }

    const openFormBtn = document.getElementById('js-open-review-form');
    const formModal = document.getElementById('capture-form-modal');
    const closeFormBtn = document.getElementById('js-close-form');
    const reviewForm = document.getElementById('capture-review-form');
    const formHeader = document.getElementById('capture-form-header');
    const successMsg = document.getElementById('capture-review-success');
    const submitBtn = document.getElementById('capture-submit-btn');

    if (openFormBtn && formModal) {
      openFormBtn.addEventListener('click', () => {
        formModal.style.display = 'flex';
        if (formHeader) formHeader.style.display = 'block';
        if (reviewForm) {
          reviewForm.reset();
          reviewForm.style.display = 'flex';
        }
        if (successMsg) successMsg.style.display = 'none';
        if (submitBtn) {
          submitBtn.disabled = false;
          submitBtn.innerText = 'Submit Review';
        }
      });
    }

    if (closeFormBtn && formModal) {
      closeFormBtn.addEventListener('click', () => {
        formModal.style.display = 'none';
      });
    }

    if (reviewForm) {
      reviewForm.addEventListener('submit', function(e) {
        e.preventDefault();
        
        if (submitBtn) {
          submitBtn.disabled = true;
          submitBtn.innerText = 'Submitting...';
        }

        const name = document.getElementById('rev-name').value;
        const email = document.getElementById('rev-email').value;
        const selectedStar = document.querySelector('input[name="Rating"]:checked');
        const rating = selectedStar ? selectedStar.value : '5';
        const text = document.getElementById('rev-text').value;

        fetch("https://formsubmit.co/ajax/support@captureshades.co", {
          method: "POST",
          headers: { 
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            _subject: `New Customer Review from ${name}`,
            Name: name,
            Email: email,
            Rating: `${rating} Stars`,
            Review: text
          })
        })
        .then(response => response.json())
        .then(() => showSuccess())
        .catch(() => showSuccess());

        function showSuccess() {
          if (formHeader) formHeader.style.display = 'none';
          if (reviewForm) reviewForm.style.display = 'none';
          if (successMsg) successMsg.style.display = 'block';
        }
      });
    }
  }

  function openImageModal() {
    const modal = document.getElementById('capture-review-modal');
    if (modal) {
      modal.style.display = 'flex';
      updateModalPhoto();
    }
  }

  function updateModalPhoto() {
    const modalImg = document.getElementById('capture-modal-img');
    const prevBtn = document.getElementById('js-modal-prev-btn');
    const nextBtn = document.getElementById('js-modal-next-btn');

    if (modalImg && activeGalleryImages.length > 0) {
      modalImg.src = activeGalleryImages[activeGalleryIndex];
    }

    if (prevBtn && nextBtn) {
      if (activeGalleryImages.length <= 1) {
        prevBtn.style.display = 'none';
        nextBtn.style.display = 'none';
      } else {
        prevBtn.style.display = 'flex';
        nextBtn.style.display = 'flex';
      }
    }
  }

  document.addEventListener('DOMContentLoaded', initReviewSection);
  document.addEventListener('shopify:section:load', initReviewSection);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cta-banner"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    if (window.__captureRevealInit) return;
    window.__captureRevealInit = true;
    var els = document.querySelectorAll('.capture-reveal');
    if (!('IntersectionObserver' in window) || !els.length) {
      els.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15 });
    els.forEach(function (el) { io.observe(el); });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["feature-rows"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var els = document.querySelectorAll('.capture-reveal');
    if (!('IntersectionObserver' in window) || !els.length) {
      els.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries, observer) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -50px 0px' });
    els.forEach(function (el) { io.observe(el); });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-capture"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    if (window.__captureRevealInit) return;
    window.__captureRevealInit = true;
    var els = document.querySelectorAll('.capture-reveal');
    if (!('IntersectionObserver' in window) || !els.length) {
      els.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15 });
    els.forEach(function (el) { io.observe(el); });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lens-sweep-banner"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    if (window.__captureRevealInit) return;
    window.__captureRevealInit = true;
    var els = document.querySelectorAll('.capture-reveal');
    if (!('IntersectionObserver' in window) || !els.length) {
      els.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15 });
    els.forEach(function (el) { io.observe(el); });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["photo-gallery"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    if (window.__captureRevealInit) return;
    window.__captureRevealInit = true;
    var els = document.querySelectorAll('.capture-reveal');
    if (!('IntersectionObserver' in window) || !els.length) {
      els.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15 });
    els.forEach(function (el) { io.observe(el); });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-and-photo-gallery"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    if (window.__captureRevealInit) return;
    window.__captureRevealInit = true;
    var els = document.querySelectorAll('.capture-reveal');
    if (!('IntersectionObserver' in window) || !els.length) {
      els.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15 });
    els.forEach(function (el) { io.observe(el); });
  });

  } catch(e) { console.error(e); }
})();
})();
